import { mergeStyleSets } from '@uifabric/merge-styles';
import { Depths } from '@uifabric/fluent-theme';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  root: {
    padding: '0 1rem',
    paddingRight: '0',
    backgroundColor: theme.palette.neutralWhite,
    minHeight: pxToRem(layout.constants.topNav.height),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 11,
    selectors: {
      '& .ms-CommandBar': {
        backgroundColor: theme.palette.neutralWhite,
        display: 'flex',
        padding: '0',
      },
      '& .ms-Button': {
        color: theme.palette.black,
        backgroundColor: theme.palette.neutralWhite,
      },
      '& .ms-OverflowSet-item': {
        display: 'flex',
        alignItems: 'center',
        minHeight: pxToRem(layout.constants.topNav.height),
      },

      '& .ms-Button.ms-Button--commandBar.ms-CommandBarItem-link': {
        height: pxToRem(48),
        width: pxToRem(48),
        paddingRight: 0,
        paddingLeft: 0,
      },

      '& .ms-Button-flexContainer': {
        borderBottom: `solid ${pxToRem(1)}`,
        borderBottomColor: theme.palette.neutralLight,
      },
    },
  },

  navbarImage: {
    height: pxToRem(20),
    display: 'flex',
    margin: '0',
  },

  verticalStyle: {
    width: pxToRem(27),
    height: pxToRem(24),
    transform: 'matrix(1, 0, 0, -1, 0, 0)',
    backgroundColor: theme.palette.neutralWhite,
  },

  persona: {
    width: pxToRem(48),
  },

  support: {
    width: pxToRem(20),
    height: pxToRem(20),
    color: theme.palette.themePrimary,
    margin: `${pxToRem(16)} ${pxToRem(18)} ${pxToRem(12)} 0`,
    fontSize: pxToRem(16),
  },

  title: {
    fontSize: pxToRem(14),
    fontWeight: 500,
    lineHeight: 1.43,
    alignVertical: 'center',
    color: theme.palette.black,
  },

  button: {
    selectors: {
      '&:hover': {
        color: '#430925',
      },
    },
    color: theme.palette.themePrimary,
    backgroundColor: `${theme.palette.neutralWhite} !important`,
    textDecoration: 'none',
    height: pxToRem(40),
    fontSize: pxToRem(14),
    lineHeight: '1.43',
    marginLeft: pxToRem(80),
    bottom: pxToRem(-1),
    paddingTop: pxToRem(16),
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
  },

  panel: {
    top: pxToRem(48),
    selectors: {
      '& .ms-Persona-details': {
        marginBottom: pxToRem(24),
        paddingLeft: pxToRem(24),
        paddingRight: 0,
      },

      '& .ms-Persona-initials': {
        fontSize: 'x-large',
      },

      '& .ms-Panel-main': {
        backgroundColor: theme.palette.neutralWhite,
        boxShadow: Depths.depth4,
      },

      '& .ms-Panel-content': {
        paddingLeft: pxToRem(16),
        paddingTop: pxToRem(37),
      },

      '& .ms-Persona-coin.ms-Persona--size72': {
        marginBottom: pxToRem(78),
      },

      '& .ms-Panel-headerText': {
        width: pxToRem(256),
        height: pxToRem(30),
        fontSize: pxToRem(22),
        fontWeight: pxToRem(600),
        lineHeight: '1.36',
        letterSpacing: 'normal',
      },

      '& .ms-Panel-header': {
        paddingTop: pxToRem(31),
        paddingLeft: pxToRem(16),
      },

      '& .ms-Panel-commands': {
        borderColor: `${theme.palette.neutralLighter} !important`,
        borderBottom: `${pxToRem(1)} solid`,
        paddingBottom: pxToRem(14),
        marginTop: pxToRem(14),
      },

      '& .ms-Persona-primaryText': {
        width: pxToRem(212),
        height: pxToRem(20),
        fontSize: pxToRem(14),
        fontWeight: '600',
        lineHeight: '1.43',
        letterSpacing: 'normal',
        color: theme.palette.neutralPrimary,
        paddingBottom: pxToRem(8),
      },

      '& .ms-Persona-secondaryText, .ms-Persona-tertiaryText': {
        width: pxToRem(212),
        height: pxToRem(16),
        fontSize: pxToRem(12),
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.33',
        letterSpacing: 'normal',
        marginTop: pxToRem(8),
        color: theme.palette.neutralSecondary,
      },

      // Close button
      '& .ms-Button.ms-Button--icon.ms-Panel-closeButton.ms-PanelAction-close': {
        width: pxToRem(20),
        height: pxToRem(19),
      },

      '& .root-493::before': {
        backgroundColor: 'rgb(243, 242, 241)',
        height: '1px',
        content: '',
        display: 'block',
        position: 'absolute',
        top: '80%',
        bottom: '0px',
        left: '0px',
        right: '0px',
      },
    },
  },

  feedBackIcon: {
    cursor: 'pointer',
    width: pxToRem(20),
    height: pxToRem(20),
    color: theme.palette.themePrimary,
    margin: `${pxToRem(16)} ${pxToRem(18)} ${pxToRem(12)} 0`,
    fontSize: pxToRem(16),
  },

  faqAlign: {
    marginTop: '9px',
    marginRight: '10px',
  },
});
